import { signInWithCustomToken } from "firebase/auth";
import { auth } from "../firebase/config";

function getLaunchApiBaseUrl() {
  const envValue = process.env.REACT_APP_GAME_LAUNCH_API_BASE_URL;
  if (typeof envValue === "string" && envValue.trim()) {
    return envValue.trim().replace(/\/+$/, "");
  }

  return "https://us-central1-infinft-card-game.cloudfunctions.net/gameLaunchApi";
}

async function parseJsonResponse(response) {
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = payload?.error || payload?.message || `Request failed with status ${response.status}`;
    const error = new Error(message);
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return payload;
}

export function getStudioLaunchSessionId() {
  if (typeof window === "undefined") {
    return "";
  }

  return new URLSearchParams(window.location.search).get("studioLaunchSession") || "";
}

export function clearStudioLaunchSessionQueryParam() {
  if (typeof window === "undefined") {
    return;
  }

  const nextUrl = new URL(window.location.href);
  nextUrl.searchParams.delete("studioLaunchSession");
  window.history.replaceState({}, document.title, nextUrl.toString());
}

export async function exchangeStudioLaunchSession(sessionId) {
  const response = await fetch(`${getLaunchApiBaseUrl()}/games/launch-session/exchange`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ sessionId }),
  });

  const payload = await parseJsonResponse(response);
  await signInWithCustomToken(auth, payload.customToken);
  return payload;
}
